import React, { useEffect, useState }       from 'react';
import AvvisiTable                          from '../../components/AvvisiTable';
import TabellaDashboardSAT                  from '../../TabellaDashboardSAT';
import InfoCard                             from '../../components/InfoCard';
import { Container, Grid }                  from '@mui/material';
import ApiService                           from '../../components/service/ApiService';
import { useTranslation }                   from 'react-i18next';


const DashboardSAT = () => {

    const { t } = useTranslation();

    const [loading,             setLoading              ] = useState(true);
    const [dataRiparazioni,     setDataRiparazioni      ] = useState([]);
    const [dataDOA,             setDataDOA              ] = useState([]);
    const [dataDanneggiata,     setDataDanneggiata      ] = useState([]);
    const [dataNonConforme,     setDataNonConforme      ] = useState([]);
    const [resiNumber,          setResiNumber           ] = useState({
        riparazione:      0,
        doa:              0,
        merceDanneggiata: 0,
        merceNonConforme: 0,
    });

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const lingua = user?.lingua;

        useEffect(() => {
            fetchDatiRMA();
        }, [lingua]);


    const fetchDatiRMA = async () => {
        setLoading(true); 
        try {
            // const responseNumber = await axios.get(`http://localhost:8080/rma/number`, { headers: headers });  
            const responseNumber = await ApiService.request("getAllNumeroRma", )  
            if (responseNumber.data) {
                setResiNumber({
                    riparazione:        responseNumber.data.riparazione         || 0,
                    doa:                responseNumber.data.doa                 || 0,
                    merceDanneggiata:   responseNumber.data.merceDanneggiata    || 0,
                    merceNonConforme:   responseNumber.data.merceNonConforme    || 0,
                });

                setDataRiparazioni([
                    { label: t('In Attesa'),                       value: responseNumber.data.riparazioniInAttesa                  || 0 },
                    { label: t('In Lavorazione'),                  value: responseNumber.data.riparazioniInLavorazione             || 0 },
                    { label: t('Accettato invio cliente'),         value: responseNumber.data.riparazioniAccettatoInvio            || 0 },
                    { label: t('Accettato attesa info ritiro'),    value: responseNumber.data.riparazioniAccettatoInAttesa         || 0 },
                    { label: t('Accettato'),                       value: responseNumber.data.riparazioniAccettato                 || 0 },
                    { label: t('Rifiutato'),                       value: responseNumber.data.riparazioniRifiutato                 || 0 },
                    { label: t('Rinviato'),                        value: responseNumber.data.riparazioniRinviato                  || 0 },
                    { label: t('Rimborsato'),                      value: responseNumber.data.riparazioniRimborsato                || 0 }
                ]);

                setDataDOA([
                    { label: t('In Attesa'),                       value: responseNumber.data.doaInAttesa                          || 0 },
                    { label: t('In Lavorazione'),                  value: responseNumber.data.doaInLavorazione                     || 0 },
                    { label: t('Accettato invio cliente'),         value: responseNumber.data.doaAccettatoInvio                    || 0 },
                    { label: t('Accettato attesa info ritiro'),    value: responseNumber.data.doaAccettatoInAttesa                 || 0 },
                    { label: t('Accettato'),                       value: responseNumber.data.doaAccettato                         || 0 },
                    { label: t('Rifiutato'),                       value: responseNumber.data.doaRifiutato                         || 0 },
                    { label: t('Rinviato'),                        value: responseNumber.data.doaRinviato                          || 0 },
                    { label: t('Rimborsato'),                      value: responseNumber.data.doaRimborsato                        || 0 }
                ]);

                setDataDanneggiata([
                    { label: t('In Attesa'),                       value: responseNumber.data.merceDanneggiataInAttesa             || 0 },
                    { label: t('In Lavorazione'),                  value: responseNumber.data.merceDanneggiataInLavorazione        || 0 },
                    { label: t('Accettato invio cliente'),         value: responseNumber.data.merceDanneggiataAccettatoInvio       || 0 },
                    { label: t('Accettato attesa info ritiro'),    value: responseNumber.data.merceDanneggiataAccettatoInAttesa    || 0 },
                    { label: t('Accettato'),                       value: responseNumber.data.merceDanneggiataAccettato            || 0 },
                    { label: t('Rifiutato'),                       value: responseNumber.data.merceDanneggiataRifiutato            || 0 },
                    { label: t('Rinviato'),                        value: responseNumber.data.merceDanneggiataRinviato             || 0 },
                    { label: t('Rimborsato'),                      value: responseNumber.data.merceDanneggiataRimborsato           || 0 }
                ]);

                setDataNonConforme([
                    { label: t('In Attesa'),                       value: responseNumber.data.merceNonConformeInAttesa             || 0 },
                    { label: t('In Lavorazione'),                  value: responseNumber.data.merceNonConformeInLavorazione        || 0 },
                    { label: t('Accettato invio cliente'),         value: responseNumber.data.merceNonConformeAccettatoInvio       || 0 },
                    { label: t('Accettato attesa info ritiro'),    value: responseNumber.data.merceNonConformeAccettatoInAttesa    || 0 },
                    { label: t('Accettato'),                       value: responseNumber.data.merceNonConformeAccettato            || 0 },
                    { label: t('Rifiutato'),                       value: responseNumber.data.merceNonConformeRifiutato            || 0 },
                    { label: t('Rinviato'),                        value: responseNumber.data.merceNonConformeRinviato             || 0 },
                    { label: t('Rimborsato'),                      value: responseNumber.data.merceNonConformeRimborsato           || 0 }
                ]);
            } else {
                console.error("I dati ottenuti da number non sono validi:", responseNumber.data);
            }
        } catch (error) {
            console.error("Errore nel recupero dei dati RMA", error);
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchDatiRMA();
    }, []);




    return (
        <Container
            maxWidth="false"
            sx={{
                height: {xs: '100%',  md: 'calc(100vh - 110px)'},
                display: 'flex',
                flexDirection: 'column',
                m: 0,
                p: 0
            }}
        >
            <Grid container spacing={2} sx={{ width: '100%', height: '100%' }}>
                <Grid container item xs={12} sx={{ height: '70%' }}>
                    <Grid item xs={12} md={9} sx={{ height: '100%', overflowY: 'none' }}>
                        <TabellaDashboardSAT 
                            updateCard={fetchDatiRMA}
                            sx={{ width: '100%' }} 
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ height: '100%', overflowY: 'none' }}>
                        <AvvisiTable />
                    </Grid>
                </Grid>
                <Grid container item xs={12} spacing={2} sx={{ height: '30%', mt: 2 }}>
                    <Grid item xs={12} md={6} lg={3}>
                        <InfoCard 
                        title={t('Riparazioni')}
                        data={dataRiparazioni} 
                        color="#28334B" />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <InfoCard 
                        title={t('DOA')} 
                        data={dataDOA} 
                        color="#975F24" />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <InfoCard 
                        title={t('Merce Danneggiata')} 
                        data={dataDanneggiata} 
                        color="#123727" />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <InfoCard 
                        title={t('Merce Non Conforme')} 
                        data={dataNonConforme} 
                        color="#952828" />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default DashboardSAT;
